import React from "react";

const Pagination = ({ currentPage, totalPages, setCurrentPage }) => {
  if (totalPages <= 1) return null; // Hide pagination if there's only 1 page

  const maxPageNumbers = 5; // Show up to 5 pages at a time
  let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbers / 2));
  let endPage = Math.min(totalPages, startPage + maxPageNumbers - 1);

  if (totalPages > maxPageNumbers) {
    if (endPage === totalPages) {
      startPage = totalPages - maxPageNumbers + 1;
    } else if (startPage === 1) {
      endPage = maxPageNumbers;
    }
  }

  return (
    <nav aria-label="Page navigation" className="custom_pagination">
      <ul className="pagination">

        {/* First Page */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage(1)} aria-label="First">
            <span aria-hidden="true"><i className="fa-solid fa-angles-left"></i></span>
          </button>
        </li>

        {/* Previous Page */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)} aria-label="Previous">
            <span aria-hidden="true"><i className="fa-solid fa-angle-left"></i></span>
          </button>
        </li>

        {/* Page Numbers */}
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
          <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
            <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
          </li>
        ))}

        {/* Next Page */}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)} aria-label="Next">
            <span aria-hidden="true"><i className="fa-solid fa-angle-right"></i></span>
          </button>
        </li>

        {/* Last Page */}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage(totalPages)} aria-label="Last">
            <span aria-hidden="true"><i className="fa-solid fa-angles-right"></i></span>
          </button>
        </li>

      </ul>
    </nav>
  );
};

export default Pagination;
